import { useCheckIns } from "../../hooks/useCheckIns";
import Error from "../common/error";
import { CheckInListCell } from "./checkInListCell";
import { Link } from "react-router-dom";
import { Loading } from "../common/Loading";
import { Pagination } from "../common/pagination";
import { twclsx } from "../../utils/cssUtil";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { userAtom } from "../../atoms/userAtom";

export function CheckInsList({
  artist,
  page,
  className,
}: Readonly<{
  artist?: string;
  page: number;
  className?: string;
}>) {
  const artistId = Number(artist) || undefined;
  const [adminUser] = useAtom(userAtom);
  const { checkInList, isLoading, isError, error } = useCheckIns(
    artistId,
    adminUser,
    page - 1,
  );
  const { t } = useTranslation();

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    if (error?.status !== 404) {
      return <Error />;
    }
  }

  return (
    <>
      {checkInList && checkInList?.checkIns.length > 0 ? (
        <div className={twclsx("flex flex-col", className)}>
          <div className={"flex flex-col divide-y"}>
            {checkInList?.checkIns.map((summary) => (
              <Link
                to={`/artists/${artistId}/events/${summary.eventId}/rewards/${summary.rewardId}`}
                key={`${summary.eventId}${summary.rewardId}`}
              >
                <CheckInListCell eventSummary={summary}></CheckInListCell>
              </Link>
            ))}
          </div>
          <Pagination className={"py-3"} page={checkInList?.page} />
        </div>
      ) : (
        <div className={"flex flex-col pt-20 items-center"}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
          <label className={"p-2"}>{t("eventlist_empty")}</label>
        </div>
      )}
    </>
  );
}
